import { LogOut, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { TopHeader, Button } from '../../components';
import { useAuth } from '../../contexts/AuthContext';

export function ProfilePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  // Get user initials for avatar
  const initials = user?.name
    ?.split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2) || 'U';

  return (
    <div className="min-h-screen">
      <TopHeader title="Profile" />

      <div className="p-6 space-y-6">
        {/* User info */}
        <div className="bg-background-card rounded-xl p-6 text-center">
          {user?.avatar_url ? (
            <img
              src={user.avatar_url}
              alt={user.name}
              className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
          ) : (
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-semibold text-primary">{initials}</span>
            </div>
          )}
          <h2 className="text-xl font-semibold text-text-primary">{user?.name}</h2>
          <p className="text-text-secondary">{user?.email}</p>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <Button
            variant="secondary"
            fullWidth
            icon={<Settings size={20} />}
            onClick={() => navigate('/settings')}
          >
            Settings
          </Button>
          <Button
            variant="tertiary"
            fullWidth
            icon={<LogOut size={20} />}
            onClick={handleLogout}
          >
            Log Out
          </Button>
        </div>
      </div>
    </div>
  );
}
